[
    {
        "id": 1,
        "key": "employee",
        "name": "会社員"
    },
    {
        "id": 2,
        "key": "civil_servants",
        "name": "公務員"
    },
    {
        "id": 3,
        "key": "self_employment",
        "name": "自営業"
    },
    {
        "id": 4,
        "key": "director",
        "name": "会社役員"
    },
    {
        "id": 5,
        "key": "freelancer",
        "name": "フリーランス"
    },
    {
        "id": 6,
        "key": "housewife_husband",
        "name": "専業主婦・主夫"
    },
    {
        "id": 7,
        "key": "student",
        "name": "学生"
    },
    {
        "id": 8,
        "key": "part_time",
        "name": "アルバイト/パート"
    },
    {
        "id": 9,
        "key": "unemployed",
        "name": "無職"
    },
    {
        "id": 99,
        "key": "other",
        "name": "その他"
    }
]
